import { useEffect } from 'react';
import { useIsRetail } from '../../../hooks/useIsRetail';
import { useRepInfo } from '../../../hooks/useRepInfo';
import { AssignableModal } from './AssignableModal';
import { UnassignableModal } from './UnassignableModal';
import { trackPurchaseMotionFailure } from '../../../utils/metrics';
import { jsx as _jsx } from "react/jsx-runtime";
const checkIsAssignable = ({
  isAssignable,
  isRetail,
  repInfo
}) => !!(isAssignable && !isRetail && repInfo !== null && repInfo !== void 0 && repInfo.link);
const CommModalContainer = ({
  apiName,
  trackingData,
  upgradeConfig,
  isAssignable,
  onClose
}) => {
  const {
    error: repInfoError,
    loading: repInfoLoading,
    repInfo
  } = useRepInfo();
  const {
    error: isRetailError,
    loading: isRetailLoading,
    isRetail
  } = useIsRetail();
  useEffect(() => {
    if (!isRetailLoading && !repInfoLoading) {
      if (isRetailError || repInfoError) {
        trackPurchaseMotionFailure({
          uniqueId: trackingData.uniqueId,
          apiName,
          purchaseMotion: 'TALK_TO_SALES'
        });
      }
    }
  }, [apiName, isRetailError, isRetailLoading, repInfoError, repInfoLoading, trackingData.uniqueId]);
  if (repInfoLoading || isRetailLoading) return null;
  if (!isRetailError && !repInfoError && repInfo && checkIsAssignable({
    isAssignable,
    isRetail,
    repInfo
  })) {
    return /*#__PURE__*/_jsx(AssignableModal, {
      apiName: apiName,
      repInfo: repInfo,
      trackingData: trackingData,
      upgradeConfig: upgradeConfig,
      onClose: onClose
    });
  }
  return /*#__PURE__*/_jsx(UnassignableModal, {
    apiName: apiName,
    isRetail: isRetail !== null && isRetail !== void 0 ? isRetail : false,
    trackingData: trackingData,
    upgradeConfig: upgradeConfig,
    onClose: onClose
  });
};
export default CommModalContainer;